import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import AppIcon from '../components/AppIcon';
import { Brain, Droplets, Sun, Wrench } from 'lucide-react';
import ProductCard from '../components/ProductCard';
import { PageSeo } from '../components/Seo';
import { useProducts } from '../context/ProductContext';
import { itemListJsonLd, organizationJsonLd, websiteJsonLd } from '../utils/structuredData';

export default function Home() {
  const { products, isLoading, refreshProducts } = useProducts();
  const featured = products.filter((p) => p.inStock);

  useEffect(() => {
    void refreshProducts({ silent: products.length > 0 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshProducts]);

  return (
    <>
      <PageSeo
        jsonLd={[organizationJsonLd(), websiteJsonLd(), itemListJsonLd(featured)]}
      />
      <section className="hero">
        <div className="container hero-content">
          <div className="hero-text">
            <span className="hero-badge">Stoktaki Ürünler</span>
            <h1>Sağlıklı Yaşam,<br />Uzun Ömür</h1>
            <p>
              tDCS, CES, hidrojenli su ve ışık terapisi cihazları ile
              yaşam kalitenizi yükseltin. Online teknik destek ile güvenle alışveriş yapın.
            </p>
            <div className="hero-actions">
              <Link to="/shop" className="btn btn-primary btn-lg">
                Ürünleri Keşfet
              </Link>
              <Link to="/shop?category=tDCS" className="btn btn-outline btn-lg">
                tDCS Cihazları
              </Link>
            </div>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <strong>{products.length}</strong>
              <span>Toplam Ürün</span>
            </div>
            <div className="stat">
              <strong>100%</strong>
              <span>Online Destek</span>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Stoktaki Ürünler</h2>
            <Link to="/shop" className="link-arrow">Tümünü Gör →</Link>
          </div>

          {isLoading ? (
            <p>Ürünler yükleniyor...</p>
          ) : (
            <div className="product-grid">
              {featured.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="section features-section">
        <div className="container">
          <h2 className="text-center">Neden HealthShopLongevity?</h2>
          <div className="features-grid">
            <div className="feature">
              <span className="feature-icon">
                <AppIcon icon={Brain} size={40} />
              </span>
              <h3>Nöromodülasyon</h3>
              <p>tDCS ve CES cihazları ile beyin stimülasyonu ve uyku desteği.</p>
            </div>
            <div className="feature">
              <span className="feature-icon">
                <AppIcon icon={Droplets} size={40} />
              </span>
              <h3>Hidrojen Teknolojisi</h3>
              <p>3500-5000 ppb hidrojen konsantrasyonlu su şişesi ile antioksidan destek.</p>
            </div>
            <div className="feature">
              <span className="feature-icon">
                <AppIcon icon={Sun} size={40} />
              </span>
              <h3>Işık Terapisi</h3>
              <p>LED güneş ışığı lambası ile mevsimsel duygu durumu desteği.</p>
            </div>
            <div className="feature">
              <span className="feature-icon">
                <AppIcon icon={Wrench} size={40} />
              </span>
              <h3>Online Destek</h3>
              <p>Tüm ürünlerde satış sonrası online destek hizmeti.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
